var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header-controls", attrs: { id: "header__controls" } },
    [
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "feedbackModal",
            title: "Send Feedback"
          }
        },
        [_c("FeedbackModal", { ref: "refFeedbackModal" })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-7 col-md-8 col-8 left-side" }, [
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c("div", { staticClass: "input-group top-search" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchQuery,
                        expression: "searchQuery"
                      },
                      {
                        name: "debounce",
                        rawName: "v-debounce:500ms",
                        value: _vm.setQuery,
                        expression: "setQuery",
                        arg: "500ms"
                      }
                    ],
                    ref: "searchQuery",
                    staticClass: "form-control media-calls-search",
                    attrs: {
                      type: "text",
                      "debounce-events": ["keyup"],
                      placeholder: "Search deliverables...",
                      id: "search-query"
                    },
                    domProps: { value: _vm.searchQuery },
                    on: {
                      click: function($event) {
                        return _vm.$refs.searchQuery.select()
                      },
                      keypress: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.generateReport()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchQuery = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "input-group-append cursor-pointer",
                      on: {
                        click: function($event) {
                          return _vm.generateReport()
                        }
                      }
                    },
                    [_vm._m(0)]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    ref: "filterBoxBtn",
                    staticClass: "ml-2 header-filter-btns",
                    attrs: {
                      id: "popover-button-event",
                      variant: "theme",
                      tabindex: "0",
                      href: "#"
                    },
                    on: {
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "esc", 27, $event.key, [
                            "Esc",
                            "Escape"
                          ])
                        ) {
                          return null
                        }
                        return _vm.$refs.popover.$emit("close")
                      }
                    }
                  },
                  [
                    _vm._v("\n            Filter\n            "),
                    _c("img", {
                      attrs: { src: require("@/csmworkflow/img/filter.svg") }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-popover",
                  {
                    ref: "popover",
                    attrs: {
                      triggers: "click blur",
                      placement: "bottom",
                      target: "popover-button-event",
                      "custom-class": "deliverable-filter"
                    }
                  },
                  [
                    _c("div", { staticClass: "d-flex flex-row" }, [
                      _c("div", { staticClass: "filter-item item__status" }, [
                        _c("label", [_vm._v("Task Status")]),
                        _vm._v(" "),
                        !_vm.isMobile()
                          ? _c(
                              "div",
                              { staticClass: "status-wrap" },
                              _vm._l(_vm.statuses, function(s, index) {
                                return _c(
                                  "a",
                                  {
                                    key: index,
                                    staticClass: "badge mr-2",
                                    style: {
                                      color: "var(--wf-secondary)",
                                      backgroundColor: s.color
                                    },
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        return _vm.setStatusFilter(s)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(s.name))]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "custom-field status-field" },
                          [
                            _vm.isMobile()
                              ? _c("multiselect", {
                                  attrs: {
                                    searchable: true,
                                    label: "name",
                                    options: _vm.statuses,
                                    placeholder: "Select status",
                                    "show-labels": false,
                                    multiple: true,
                                    "hide-selected": true
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "option",
                                        fn: function(props) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                style: {
                                                  color: "var(--wf-secondary)",
                                                  borderRadius: "10px",
                                                  backgroundColor:
                                                    props.option.color,
                                                  height: "40px",
                                                  lineHeight: "40px",
                                                  textAlign: "center"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(props.option.name)
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "tag",
                                        fn: function(props) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                style: {
                                                  color: "var(--wf-secondary)",
                                                  borderRadius: "10px",
                                                  backgroundColor:
                                                    props.option.color,
                                                  textAlign: "center",
                                                  display: "inline-block",
                                                  padding: "5px 10px",
                                                  marginRight: "5px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(props.option.name)
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1936226673
                                  ),
                                  model: {
                                    value: _vm.filterQuery.status,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filterQuery, "status", $$v)
                                    },
                                    expression: "filterQuery.status"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "grouped-filter-item" }, [
                        _c(
                          "div",
                          { staticClass: "filter-item item__outlet" },
                          [
                            _c(
                              "div",
                              [
                                _c("label", [_vm._v("Contact")]),
                                _vm._v(" "),
                                _vm.isMobile()
                                  ? _c(
                                      "b-form-checkbox",
                                      {
                                        staticClass: "float-right csm-checkbox",
                                        attrs: {
                                          id: "no-outlet",
                                          name: "no-outlet",
                                          value: "accepted",
                                          "unchecked-value": "not_accepted"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.filterQuery.noOutlet ==
                                            "accepted"
                                              ? (_vm.filterQuery.outlet = [])
                                              : ""
                                          }
                                        },
                                        model: {
                                          value: _vm.filterQuery.noOutlet,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "noOutlet",
                                              $$v
                                            )
                                          },
                                          expression: "filterQuery.noOutlet"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      No Contact\n                    "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "outlet-wrap" },
                              [
                                _c(
                                  "multiselect",
                                  {
                                    ref: "outletFilter",
                                    attrs: {
                                      "track-by": "id",
                                      id: "id",
                                      "open-direction": "bottom",
                                      label: "name",
                                      options: _vm.contacts,
                                      "show-labels": false,
                                      searchable: true,
                                      multiple: true,
                                      "options-limit": 300,
                                      "close-on-select": false,
                                      "internal-search": false,
                                      "hide-selected": true,
                                      "preserve-search": true,
                                      "clear-on-select": false,
                                      "show-no-results": false,
                                      "max-height": 600,
                                      loading: _vm.isContactsLoading
                                    },
                                    on: {
                                      select: function($event) {
                                        _vm.filterQuery.noOutlet =
                                          "not_accepted"
                                      },
                                      "search-change": _vm.onWhoSearch
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "selection",
                                        fn: function(ref) {
                                          var values = ref.values
                                          var search = ref.search
                                          var isOpen = ref.isOpen
                                          return [
                                            values.length && !isOpen
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "multiselect__single"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(values.length) +
                                                        " options selected"
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        }
                                      },
                                      {
                                        key: "option",
                                        fn: function(props) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "option__desc" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "option__title"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(props.option.name)
                                                    )
                                                  ]
                                                ),
                                                _c("br"),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "option__small text-muted"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.option
                                                          .company_name
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ]),
                                    model: {
                                      value: _vm.filterQuery.outlet,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filterQuery, "outlet", $$v)
                                      },
                                      expression: "filterQuery.outlet"
                                    }
                                  },
                                  [
                                    _vm._v(" "),
                                    _vm._v(" "),
                                    _c("template", { slot: "noOptions" }, [
                                      _vm._v(
                                        "\n                        Start typing to find contacts.\n                      "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("template", { slot: "noResult" }, [
                                      _vm._v(
                                        "\n                        No results. Please try changing the search query.\n                      "
                                      )
                                    ])
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.isMobile()
                              ? _c(
                                  "b-form-checkbox",
                                  {
                                    staticClass: "mt-2 csm-checkbox",
                                    attrs: {
                                      id: "no-outlet",
                                      name: "no-outlet",
                                      value: "accepted",
                                      "unchecked-value": "not_accepted"
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.filterQuery.noOutlet == "accepted"
                                          ? (_vm.filterQuery.outlet = [])
                                          : ""
                                      }
                                    },
                                    model: {
                                      value: _vm.filterQuery.noOutlet,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filterQuery,
                                          "noOutlet",
                                          $$v
                                        )
                                      },
                                      expression: "filterQuery.noOutlet"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    No Contact\n                  "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "filter-item item__outlet" }, [
                          _c("label", [_vm._v("Company")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "outlet-wrap" },
                            [
                              _c("multiselect", {
                                ref: "outletCompanyFilter",
                                attrs: {
                                  id: "id",
                                  "open-direction": "bottom",
                                  options: _vm.allCompanies,
                                  "show-labels": false,
                                  searchable: true,
                                  multiple: true,
                                  "options-limit": 300,
                                  "close-on-select": false,
                                  "hide-selected": true,
                                  "preserve-search": true,
                                  "clear-on-select": false,
                                  "show-no-results": false,
                                  "max-height": 600
                                },
                                model: {
                                  value: _vm.filterQuery.outletCompany,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filterQuery,
                                      "outletCompany",
                                      $$v
                                    )
                                  },
                                  expression: "filterQuery.outletCompany"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item item__coordinator" },
                          [
                            _c("label", [_vm._v("Coordinator")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "coordinator-wrap" },
                              [
                                _c("multiselect", {
                                  ref: "coordinatorFilter",
                                  attrs: {
                                    options: _vm.allUsers,
                                    "show-labels": false,
                                    multiple: true,
                                    "open-direction": "bottom",
                                    label: "name",
                                    "track-by": "id",
                                    hideSelected: false,
                                    "hide-selected": false,
                                    "close-on-select": false,
                                    "clear-on-select": false
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "selection",
                                      fn: function(ref) {
                                        var values = ref.values
                                        var search = ref.search
                                        var isOpen = ref.isOpen
                                        return [
                                          values.length && !isOpen
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "multiselect__single"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(values.length) +
                                                      " options selected"
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.filterQuery.coordinator,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.filterQuery,
                                        "coordinator",
                                        $$v
                                      )
                                    },
                                    expression: "filterQuery.coordinator"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "grouped-filter-item" }, [
                        _c(
                          "div",
                          { staticClass: "filter-item item__department" },
                          [
                            _c(
                              "div",
                              [
                                _c("label", [
                                  _vm._v(
                                    "\n                      Department\n                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.isMobile()
                                  ? _c(
                                      "b-form-checkbox",
                                      {
                                        staticClass: "float-right csm-checkbox",
                                        attrs: {
                                          id: "no-department",
                                          name: "no-department",
                                          value: "accepted",
                                          "unchecked-value": "not_accepted"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.filterQuery.noDepartment ==
                                            "accepted"
                                              ? (_vm.filterQuery.department = [])
                                              : ""
                                          }
                                        },
                                        model: {
                                          value: _vm.filterQuery.noDepartment,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "noDepartment",
                                              $$v
                                            )
                                          },
                                          expression: "filterQuery.noDepartment"
                                        }
                                      },
                                      [_vm._v("No Department")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "tag-wrap" },
                              [
                                _c(
                                  "multiselect",
                                  {
                                    ref: "departmentFilter",
                                    attrs: {
                                      "open-direction": "bottom",
                                      label: "name",
                                      "track-by": "id",
                                      options: _vm.departments,
                                      hideSelected: false,
                                      "hide-selected": false,
                                      "show-labels": false,
                                      multiple: true,
                                      "close-on-select": false,
                                      "clear-on-select": false
                                    },
                                    on: {
                                      select: function($event) {
                                        _vm.filterQuery.noDepartment =
                                          "not_accepted"
                                      }
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "selection",
                                        fn: function(ref) {
                                          var values = ref.values
                                          var search = ref.search
                                          var isOpen = ref.isOpen
                                          return [
                                            values.length && !isOpen
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "multiselect__single"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(values.length) +
                                                        " options selected"
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        }
                                      }
                                    ]),
                                    model: {
                                      value: _vm.filterQuery.department,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filterQuery,
                                          "department",
                                          $$v
                                        )
                                      },
                                      expression: "filterQuery.department"
                                    }
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("template", { slot: "noOptions" }, [
                                      _vm._v(
                                        "\n                        Start typing to find departments.\n                      "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("template", { slot: "noResult" }, [
                                      _vm._v(
                                        "\n                        No results. Please try changing the search query.\n                      "
                                      )
                                    ])
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.isMobile()
                              ? _c(
                                  "b-form-checkbox",
                                  {
                                    staticClass: "mt-2 csm-checkbox",
                                    attrs: {
                                      id: "no-department",
                                      name: "no-department",
                                      value: "accepted",
                                      "unchecked-value": "not_accepted"
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.filterQuery.noDepartment ==
                                        "accepted"
                                          ? (_vm.filterQuery.department = [])
                                          : ""
                                      }
                                    },
                                    model: {
                                      value: _vm.filterQuery.noDepartment,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filterQuery,
                                          "noDepartment",
                                          $$v
                                        )
                                      },
                                      expression: "filterQuery.noDepartment"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    No Department\n                  "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "filter-item item__tag" }, [
                          _c("label", [_vm._v("Tag")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "tag-wrap" },
                            [
                              _c(
                                "multiselect",
                                {
                                  ref: "tagFilter",
                                  attrs: {
                                    options: _vm.tags,
                                    "show-labels": false,
                                    multiple: true,
                                    "open-direction": "bottom",
                                    label: "name",
                                    "track-by": "id",
                                    hideSelected: false,
                                    "hide-selected": false,
                                    "close-on-select": false,
                                    "clear-on-select": false,
                                    loading: _vm.isTagsLoading,
                                    "preserve-search": true
                                  },
                                  on: { "search-change": _vm.onTagSearch },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "selection",
                                      fn: function(ref) {
                                        var values = ref.values
                                        var search = ref.search
                                        var isOpen = ref.isOpen
                                        return [
                                          values.length && !isOpen
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "multiselect__single"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(values.length) +
                                                      " options selected"
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.filterQuery.tag,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filterQuery, "tag", $$v)
                                    },
                                    expression: "filterQuery.tag"
                                  }
                                },
                                [
                                  _vm._v(" "),
                                  _c("template", { slot: "noOptions" }, [
                                    _vm._v(
                                      "\n                        Start typing to find tags.\n                      "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("template", { slot: "noResult" }, [
                                    _vm._v(
                                      "\n                        No results. Please try changing the search query.\n                      "
                                    )
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "filter-item item__date" }, [
                        _c("div", { staticClass: "due__created__dates" }, [
                          _c(
                            "div",
                            [
                              _c("label", [_vm._v("Due Date")]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("date-range-picker", {
                                ref: "picker",
                                attrs: {
                                  autoApply: true,
                                  showDropdowns: true,
                                  ranges: _vm.customDueDateRanges
                                },
                                on: { update: _vm.onUpdateDueDate },
                                model: {
                                  value: _vm.filterQuery.dateRange,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filterQuery, "dateRange", $$v)
                                  },
                                  expression: "filterQuery.dateRange"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("label", { staticClass: "mt-2" }, [
                                _vm._v("Created")
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("date-range-picker", {
                                ref: "pickerDateCreated",
                                attrs: {
                                  autoApply: true,
                                  showDropdowns: true,
                                  ranges: _vm.customCreatedDateRanges
                                },
                                on: { update: _vm.onUpdateDateCreated },
                                model: {
                                  value: _vm.filterQuery.dateCreatedRange,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filterQuery,
                                      "dateCreatedRange",
                                      $$v
                                    )
                                  },
                                  expression: "filterQuery.dateCreatedRange"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("label", { staticClass: "mt-2" }, [
                              _vm._v("Completed")
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("date-range-picker", {
                              ref: "pickerDateCompleted",
                              attrs: {
                                autoApply: true,
                                showDropdowns: true,
                                ranges: _vm.customCompletedDateRanges
                              },
                              on: { update: _vm.onUpdateDateCompleted },
                              model: {
                                value: _vm.filterQuery.dateCompletedRange,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filterQuery,
                                    "dateCompletedRange",
                                    $$v
                                  )
                                },
                                expression: "filterQuery.dateCompletedRange"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "filter-item filter-item-no-border item__priority"
                        },
                        [
                          _c("label", [_vm._v("Priority")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "filter-rating",
                              on: { click: _vm.setPriority }
                            },
                            [
                              _c("vue-star-rate", {
                                attrs: {
                                  rateRange: _vm.filterQuery.priorityFilter,
                                  maxIcon: 5,
                                  iconHeight: 17,
                                  iconWidth: 17,
                                  hasCounter: false,
                                  iconColor: "var(--wf-primary)",
                                  iconColorHover: "var(--wf-primary)",
                                  iconShape: "circle"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "item__reset" },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              attrs: {
                                variant: "theme",
                                title: "Reset All Filter",
                                size: "sm"
                              },
                              on: { click: _vm.resetFilter }
                            },
                            [_c("i", { staticClass: "fas fa-undo" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "d-block d-md-none",
                              attrs: {
                                variant: "theme",
                                title: "Close Filter Popup",
                                size: "sm"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$refs.popover.$emit("close")
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-times" })]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isFilterActive()
                      ? _c(
                          "div",
                          { staticClass: "d-none d-md-block mt-3" },
                          [
                            _c("label", [_vm._v("Click to remove filters:")]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "badge badge-primary mr-2 mb-2",
                                style: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    _vm.filterQuery.query = ""
                                    _vm.searchQuery = ""
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.filterQuery.query))]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.filterQuery.status, function(status) {
                              return _c(
                                "span",
                                {
                                  staticClass: "badge mr-2 mb-2",
                                  style: {
                                    cursor: "pointer",
                                    color: "var(--wf-secondary)",
                                    backgroundColor: status.color
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeFilter(status)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(status.name))]
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.filterQuery.outlet, function(outlet) {
                              return _c(
                                "span",
                                {
                                  staticClass: "badge badge-primary mr-2 mb-2",
                                  style: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeFilter(outlet)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(outlet.name))]
                              )
                            }),
                            _vm._v(" "),
                            _vm.filterQuery.priorityFilter > 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeFilter(
                                          "resetPriorityFilter"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Priority " +
                                        _vm._s(_vm.filterQuery.priorityFilter)
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.filterQuery.coordinator, function(
                              coordinator
                            ) {
                              return _c(
                                "span",
                                {
                                  staticClass: "badge badge-primary mr-2 mb-2",
                                  style: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeFilter(coordinator)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(coordinator.name))]
                              )
                            }),
                            _vm._v(" "),
                            _vm.filterQuery.filterByDate
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeFilter("filterByDate")
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Due Date: " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.dateRange.startDate,
                                            "MMM DD"
                                          )
                                        ) +
                                        " - " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.dateRange.endDate,
                                            "MMM DD"
                                          )
                                        )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.filterQuery.filterNoDueDate == 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        _vm.filterQuery.filterNoDueDate = false
                                      }
                                    }
                                  },
                                  [_vm._v("No Due Date")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.filterQuery.filterByDateCreated
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeFilter(
                                          "filterByDateCreated"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Created: " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.dateCreatedRange
                                              .startDate,
                                            "MMM DD"
                                          )
                                        ) +
                                        " - " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.dateCreatedRange
                                              .endDate,
                                            "MMM DD"
                                          )
                                        )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.filterQuery.filterByDateCompleted
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeFilter(
                                          "filterByDateCompleted"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Completed: " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.dateCompletedRange
                                              .startDate,
                                            "MMM DD"
                                          )
                                        ) +
                                        " - " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.dateCompletedRange
                                              .endDate,
                                            "MMM DD"
                                          )
                                        )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.filterQuery.tag, function(tag) {
                              return _c(
                                "span",
                                {
                                  staticClass: "badge badge-primary mr-2 mb-2",
                                  style: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeFilter(tag)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(tag.name))]
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.filterQuery.department, function(
                              department
                            ) {
                              return _c(
                                "span",
                                {
                                  staticClass: "badge badge-primary mr-2 mb-2",
                                  style: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeFilter(department)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(department.name))]
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.filterQuery.outletCompany, function(
                              company
                            ) {
                              return _c(
                                "span",
                                {
                                  staticClass: "badge badge-primary mr-2 mb-2",
                                  style: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeFilter({
                                        company_name: company
                                      })
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(company))]
                              )
                            }),
                            _vm._v(" "),
                            _vm.filterQuery.noDepartment == "accepted"
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        _vm.filterQuery.noDepartment =
                                          "not_accepted"
                                      }
                                    }
                                  },
                                  [_vm._v("No Department")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.filterQuery.noOutlet == "accepted"
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        _vm.filterQuery.noOutlet =
                                          "not_accepted"
                                      }
                                    }
                                  },
                                  [_vm._v("No Outlet")]
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "report-type mr-2" },
                  [
                    _c("multiselect", {
                      ref: "reportType",
                      attrs: {
                        options: _vm.allReports,
                        "show-labels": false,
                        multiple: false,
                        "allow-empty": false,
                        "track-by": "id",
                        label: "name",
                        "open-direction": "bottom"
                      },
                      on: {
                        input: function($event) {
                          _vm.$emit("reportTypeChanged", _vm.reportType)
                          _vm.generateReport()
                        }
                      },
                      model: {
                        value: _vm.reportType,
                        callback: function($$v) {
                          _vm.reportType = $$v
                        },
                        expression: "reportType"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("b-form-group", [
                  _vm.isMobile()
                    ? _c(
                        "div",
                        { staticClass: "mobile__date__triggers" },
                        [
                          _c("multiselect", {
                            ref: "dateFilterTrigger",
                            attrs: {
                              options: _vm.dateTriggers,
                              "show-labels": false,
                              multiple: false,
                              "allow-empty": false,
                              "open-direction": "bottom"
                            },
                            on: { input: _vm.setDateTriggerMobile },
                            model: {
                              value: _vm.triggerSelected,
                              callback: function($$v) {
                                _vm.triggerSelected = $$v
                              },
                              expression: "triggerSelected"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMobile()
                    ? _c("div", [
                        _c(
                          "label",
                          { staticClass: "btn-theme date-filter-triggers" },
                          [
                            _c(
                              "b-form-radio",
                              {
                                ref: "weekly",
                                staticClass: "csm-checkbox",
                                attrs: {
                                  id: "weekly",
                                  value: "weekly",
                                  name: "createdDateTrigger"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.filterQuery.filterByDateCreated = true
                                    _vm.filterQuery.dateCreatedRange.startDate = _vm
                                      .$moment()
                                      .subtract(7, "days")
                                      .startOf("week")
                                      .format()
                                    _vm.filterQuery.dateCreatedRange.endDate = _vm
                                      .$moment()
                                      .subtract(7, "days")
                                      .endOf("week")
                                      .format()
                                  }
                                },
                                model: {
                                  value: _vm.triggerSelected,
                                  callback: function($$v) {
                                    _vm.triggerSelected = $$v
                                  },
                                  expression: "triggerSelected"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  Weekly\n                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "btn-theme ml-2 date-filter-triggers"
                          },
                          [
                            _c(
                              "b-form-radio",
                              {
                                ref: "biweekly",
                                staticClass: "csm-checkbox",
                                attrs: {
                                  value: "biweekly",
                                  id: "biweekly",
                                  name: "createdDateTrigger"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.filterQuery.filterByDateCreated = true
                                    _vm.filterQuery.dateCreatedRange.startDate = _vm
                                      .$moment()
                                      .subtract(14, "days")
                                      .startOf("week")
                                      .format()
                                    _vm.filterQuery.dateCreatedRange.endDate = _vm
                                      .$moment()
                                      .subtract(7, "days")
                                      .endOf("week")
                                      .format()
                                  }
                                },
                                model: {
                                  value: _vm.triggerSelected,
                                  callback: function($$v) {
                                    _vm.triggerSelected = $$v
                                  },
                                  expression: "triggerSelected"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  Bi-Weekly\n                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "btn-theme ml-2 date-filter-triggers"
                          },
                          [
                            _c(
                              "b-form-radio",
                              {
                                ref: "monthly",
                                staticClass: "csm-checkbox",
                                attrs: {
                                  id: "monthly",
                                  value: "monthly",
                                  name: "createdDateTrigger"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.filterQuery.filterByDateCreated = true
                                    _vm.filterQuery.dateCreatedRange.startDate = _vm
                                      .$moment()
                                      .subtract(1, "months")
                                      .startOf("month")
                                      .format()
                                    _vm.filterQuery.dateCreatedRange.endDate = _vm
                                      .$moment()
                                      .subtract(1, "months")
                                      .endOf("month")
                                      .format()
                                  }
                                },
                                model: {
                                  value: _vm.triggerSelected,
                                  callback: function($$v) {
                                    _vm.triggerSelected = $$v
                                  },
                                  expression: "triggerSelected"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  Monthly\n                "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ml-2" }, [_c("FeedbackBtn")], 1)
              ],
              1
            ),
            _vm._v(" "),
            _vm.isFilterActive()
              ? _c(
                  "div",
                  { staticClass: "mt-3" },
                  [
                    _c("label", { staticClass: "remove-filter-text" }, [
                      _vm._v("Click to remove filters:")
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "badge badge-primary mr-2 mb-2",
                        style: { cursor: "pointer" },
                        on: {
                          click: function($event) {
                            _vm.filterQuery.query = ""
                            _vm.searchQuery = ""
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.filterQuery.query))]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.status, function(status) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge mr-2 mb-2",
                          style: {
                            cursor: "pointer",
                            color: "var(--wf-secondary)",
                            backgroundColor: status.color
                          },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(status)
                            }
                          }
                        },
                        [_vm._v(_vm._s(status.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm.filterQuery.priorityFilter > 0
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("resetPriorityFilter")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Priority " +
                                _vm._s(_vm.filterQuery.priorityFilter)
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.outlet, function(outlet) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(outlet)
                            }
                          }
                        },
                        [_vm._v(_vm._s(outlet.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.coordinator, function(coordinator) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(coordinator)
                            }
                          }
                        },
                        [_vm._v(_vm._s(coordinator.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm.filterQuery.filterByDate
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByDate")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Due Date: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateRange.startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateRange.endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.filterNoDueDate == 1
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                _vm.filterQuery.filterNoDueDate = false
                              }
                            }
                          },
                          [_vm._v("No Due Date")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.filterByDateCreated
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByDateCreated")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Created: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateCreatedRange.startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateCreatedRange.endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.filterByDateCompleted
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByDateCompleted")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Completed: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateCompletedRange
                                      .startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateCompletedRange.endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.tag, function(tag) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(tag)
                            }
                          }
                        },
                        [_vm._v(_vm._s(tag.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.department, function(department) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(department)
                            }
                          }
                        },
                        [_vm._v(_vm._s(department.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.outletCompany, function(company) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter({ company_name: company })
                            }
                          }
                        },
                        [_vm._v(_vm._s(company))]
                      )
                    }),
                    _vm._v(" "),
                    _vm.filterQuery.noDepartment == "accepted"
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                _vm.filterQuery.noDepartment = "not_accepted"
                              }
                            }
                          },
                          [_vm._v("No Department")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.noOutlet == "accepted"
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                _vm.filterQuery.noOutlet = "not_accepted"
                              }
                            }
                          },
                          [_vm._v("No Outlet")]
                        )
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-5 col-md-4 col-4 text-right right-side" },
            [
              _c(
                "div",
                { staticClass: "logo-user" },
                [
                  _c("HeaderNotification"),
                  _vm._v(" "),
                  _c("LoggedInUser"),
                  _vm._v(" "),
                  _c("Logo")
                ],
                1
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "input-group-text" }, [
      _c("i", { staticClass: "fas fa-search" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }